export const REPORT_TEMPLATE_REQUIRED = 'Choose a template with content, or add content to the selected template before generating a report.';
export const REPORT_SOURCES_REQUIRED = 'Add transcription or notes, or select source files with content before generating a report.';
export const MAX_REPORT_NOTES_CHARS = 200000;
export const REPORT_NOTES_TOO_LONG = 'Report source text exceeds the 200,000-character limit. Use fewer sources or shorten the text before generating. No report credits were charged.';

// Rich text editors can contain formatting without any readable content.
export function hasReportInputText(value) {
  if (typeof value !== 'string') return false;
  const doc = new DOMParser().parseFromString(value, 'text/html');
  doc.querySelectorAll('script, style, template').forEach(node => node.remove());
  return Boolean(doc.body.textContent.replace(/[\u00a0\u200b-\u200d\ufeff]/g, ' ').trim());
}

export function validateReportInput(template, notes, fileReferences = []) {
  if (!hasReportInputText(template)) throw new Error(REPORT_TEMPLATE_REQUIRED);
  // Match Python len(str): a supplementary Unicode character counts once.
  if (typeof notes === 'string' && notes.length > MAX_REPORT_NOTES_CHARS
    && Array.from(notes).length > MAX_REPORT_NOTES_CHARS) throw new Error(REPORT_NOTES_TOO_LONG);
  // The backend resolves authorized PDFs/images and their saved OCR text.
  if (!hasReportInputText(notes) && !fileReferences.length) throw new Error(REPORT_SOURCES_REQUIRED);
}
